const jackpotsComponentsController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        RELOAD_JACKPOTS_COMPONENTS: {
          target: 'updatingJackpots',
        },
      },
    },
    updatingJackpots: {
      invoke: {
        src: 'getJackpotsComponentsContent',
        onDone: {
          actions: {
            type: 'batchLayoutOperations',
            data: '$event.data.updates',
            meta: {
              selectors: ['$action.data'],
            },
          },
          target: 'controllerIdle',
        },
      },
    },
  },
};

export default jackpotsComponentsController;
